'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PromizeAttribute = function (_React$Component) {
    _inherits(PromizeAttribute, _React$Component);

    function PromizeAttribute() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, PromizeAttribute);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PromizeAttribute.__proto__ || Object.getPrototypeOf(PromizeAttribute)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            pzImageSpacing: {},
            pzTextSpacing: {},
            pzTextSize: {}
        }, _this.pzGetAttributeValues = function () {
            var pzTab = _this.props.pzSubTab ? _this.props.pzSubTab : _this.props.pzTab;
            var pzTabAttributes = pzTab.promize_tab_attributes;
            var pzCustomizer = _this.props.pzCustomizer;
            var _this$props = _this.props,
                pzCopyRepeatObjects = _this$props.pzCopyRepeatObjects,
                pzCopyOuterObjKeys = _this$props.pzCopyOuterObjKeys,
                pzCopyInnerObjKeys = _this$props.pzCopyInnerObjKeys,
                pzCopyArraykeys = _this$props.pzCopyArraykeys,
                pzPopupBackgroundAttr = _this$props.pzPopupBackgroundAttr;
            //let pzDefaultOptions = this.props.pzDefaultOptions;

            var pzDomainId = pzCustomizer.product.domain_id;
            pzTabAttributes.length > 0 && pzTabAttributes.map(function (pzAttribute, index) {
                if (!pzCustomizer.attributes[pzTab.promize_tab_id]) {
                    pzCustomizer.attributes[pzTab.promize_tab_id] = {};
                }
                pzCustomizer.attributes[pzTab.promize_tab_id][pzAttribute.promize_tab_attribute_id] = pzAttribute;
                if (pzAttribute.promize_attribute) {
                    var attributeType = pzAttribute.promize_attribute.attribute_type;
                    var tabAttributeId = pzAttribute.promize_tab_attribute_id;
                    if (attributeType == "option") {
                        fetch(_this.props.pzApiUrl + 'getAttributesValues/?id=' + tabAttributeId).then(function (res) {
                            return res.json();
                        }).then(function (response) {
                            response.option_attributes.length > 0 && response.option_attributes.map(function (attribute_value, attribute_value_idex) {
                                if (pzCustomizer.attributeOptions[tabAttributeId] == undefined) {
                                    pzCustomizer.attributeOptions[tabAttributeId] = {};
                                }
                                pzCustomizer.attributeOptions[tabAttributeId][attribute_value.promize_tab_attribute_values_id] = attribute_value;

                                attribute_value.promize_sub_tabs.length > 0 && attribute_value.promize_sub_tabs.map(function (subTab, subTabIdx) {
                                    if (pzCustomizer.attributeOptions[tabAttributeId][attribute_value.promize_tab_attribute_values_id]['promizeSubTabs'] == undefined) {
                                        pzCustomizer.attributeOptions[tabAttributeId][attribute_value.promize_tab_attribute_values_id]['promizeSubTabs'] = {};
                                    }
                                    pzCustomizer.attributeOptions[tabAttributeId][attribute_value.promize_tab_attribute_values_id]['promizeSubTabs'][subTab.child_tab_id] = subTab;
                                    if (pzCustomizer.subtabs[pzTab.promize_tab_id] == undefined) {
                                        pzCustomizer.subtabs[pzTab.promize_tab_id] = {};
                                    }
                                    pzCustomizer.subtabs[pzTab.promize_tab_id][subTab.child_tab_id] = subTab;
                                });
                            });

                            _this.props.HomeComponent.setState({ pzCustomizer: pzCustomizer });
                        });
                    } else if (attributeType == "text") {
                        if (Object.keys(pzCustomizer.attributeDomainTexts).length == 0) {
                            fetch(_this.props.pzApiUrl + 'getDomainTextSettings/?id=' + pzDomainId).then(function (res) {
                                return res.json();
                            }).then(function (response) {
                                pzCustomizer.attributeDomainTexts['fontColor'] = {};
                                pzCustomizer.attributeDomainTexts['fontFamilies'] = {};
                                pzCustomizer.attributeDomainTexts['fontShapes'] = {};
                                pzCustomizer.attributeDomainTexts['fontSizes'] = {};
                                pzCustomizer.attributeDomainTexts['textAligns'] = {};
                                response.font_colors.length > 0 && response.font_colors.map(function (attribute_font_colors) {
                                    pzCustomizer.attributeDomainTexts['fontColor'][attribute_font_colors.promize_font_color_id] = attribute_font_colors;
                                });
                                response.font_families.length > 0 && response.font_families.map(function (attribute_font_family) {
                                    var newStyle = document.createElement('style');
                                    newStyle.appendChild(document.createTextNode("\
                                  @font-face {\
                                  font-family: " + attribute_font_family.font_name + ";\
                                  src: url('https://lanyard.wristbands.com/node/assets/fonts/" + attribute_font_family.font_file + "');\
                                  }\
                                  "));
                                    document.head.appendChild(newStyle);
                                    pzCustomizer.attributeDomainTexts['fontFamilies'][attribute_font_family.font_id] = attribute_font_family;
                                });
                                response.font_shapes.length > 0 && response.font_shapes.map(function (attribute_font_shapes) {
                                    pzCustomizer.attributeDomainTexts['fontShapes'][attribute_font_shapes.font_shape_id] = attribute_font_shapes;
                                });
                                response.font_sizes.length > 0 && response.font_sizes.map(function (attribute_font_sizes) {
                                    pzCustomizer.attributeDomainTexts['fontSizes'][attribute_font_sizes.font_size_id] = attribute_font_sizes;
                                });
                                response.text_aligns.length > 0 && response.text_aligns.map(function (attribute_text_aligns) {
                                    pzCustomizer.attributeDomainTexts['textAligns'][attribute_text_aligns.text_align_id] = attribute_text_aligns;
                                });
                                _this.props.HomeComponent.setState({ pzCustomizer: pzCustomizer });
                            });
                        }
                        fetch(_this.props.pzApiUrl + 'getAttributesTextValues/?id=' + tabAttributeId).then(function (res) {
                            return res.json();
                        }).then(function (response) {
                            response.text_attributes.length > 0 && response.text_attributes.map(function (attribute_text, attribute_text_index) {
                                if (pzCustomizer.attributeTexts[tabAttributeId] == undefined) {
                                    pzCustomizer.attributeTexts[tabAttributeId] = {};
                                }
                                pzCustomizer.attributeTexts[tabAttributeId] = attribute_text;
                                //pzCustomizer.attributeTexts[tabAttributeId][attribute_text.promize_tab_text_attribute_values_id]['attr_key'] = pzTab.promize_tab_id;

                                // pzDefaultOptions[tabAttributeId] = (attribute_text.default_text) ? attribute_text : '';
                                //console.log('%c pzTab.tab_name  ' + pzTab.tab_name, 'font-weight:bold; background: yellow; color: white');

                                var tabAdditionalData = pzTab.additional_data ? JSON.parse(pzTab.additional_data) : '';

                                if (tabAdditionalData && tabAdditionalData.tab_code == "front_text_image") {
                                    var keyIdx = attributeType + '_' + tabAttributeId;
                                    pzCopyRepeatObjects.push(keyIdx);
                                    pzCopyOuterObjKeys.push(keyIdx);
                                }
                                if (tabAdditionalData && tabAdditionalData.tab_code == "back_text_image") {
                                    var _keyIdx = attributeType + '_' + tabAttributeId;
                                    pzCopyRepeatObjects.push(_keyIdx);
                                    pzCopyInnerObjKeys.push(_keyIdx);
                                    pzCopyArraykeys[tabAttributeId] = pzTab.promize_tab_id;
                                }
                            });
                            _this.props.HomeComponent.setState({ pzCustomizer: pzCustomizer, pzCopyRepeatObjects: pzCopyRepeatObjects, pzCopyOuterObjKeys: pzCopyOuterObjKeys, pzCopyInnerObjKeys: pzCopyInnerObjKeys,pzCopyArraykeys:pzCopyArraykeys });
                        });
                    } else if (attributeType == "image") {
                        //console.log("tabAttributeId ", tabAttributeId)
                        fetch(_this.props.pzApiUrl + 'getAttributesImageValues/?id=' + tabAttributeId).then(function (res) {
                            return res.json();
                        }).then(function (response) {
                            response.image_attributes.length > 0 && response.image_attributes.map(function (attribute_image, attribute_image_index) {
                                if (pzCustomizer.attributeImages[tabAttributeId] == undefined) {
                                    pzCustomizer.attributeImages[tabAttributeId] = {};
                                }
                                pzCustomizer.attributeImages[tabAttributeId] = attribute_image;
                                var tabAdditionalData = pzTab.additional_data ? JSON.parse(pzTab.additional_data) : '';
                                if (tabAdditionalData && tabAdditionalData.tab_code == "front_text_image") {
                                    var keyIdx = 'image_' + tabAttributeId;
                                    pzCopyRepeatObjects.push(keyIdx);
                                    pzCopyOuterObjKeys.push(keyIdx);
                                }
                                if (tabAdditionalData && tabAdditionalData.tab_code == "back_text_image") {
                                    var _keyIdx2 = 'image_' + tabAttributeId;
                                    pzCopyRepeatObjects.push(_keyIdx2);
                                    pzCopyInnerObjKeys.push(_keyIdx2);
                                    pzCopyArraykeys[tabAttributeId] = pzTab.promize_tab_id;
                                }
                                if (pzAttribute.promize_attribute.attribute_code.toLowerCase() == "background") {
                                    pzPopupBackgroundAttr['tabId'] = pzTab.promize_tab_id;
                                }
                            });
                            _this.props.HomeComponent.setState({ pzCustomizer: pzCustomizer, pzCopyRepeatObjects: pzCopyRepeatObjects, pzCopyOuterObjKeys: pzCopyOuterObjKeys, pzCopyInnerObjKeys: pzCopyInnerObjKeys, pzPopupBackgroundAttr: pzPopupBackgroundAttr,pzCopyArraykeys : pzCopyArraykeys });
                        });
                    }

                    // else if (attributeType == "clipart") {
                    //     fetch(this.props.pzApiUrl + 'getAttributesClipartValues/?id=' + tabAttributeId)
                    //         .then(res => res.json())
                    //         .then(response => {
                    //             response.clipart_attributes.length > 0 && response.clipart_attributes.map((attribute_clipart, attribute_clipart_index) => {
                    //                 if (pzCustomizer.attributeCliparts[tabAttributeId] == undefined) {
                    //                     pzCustomizer.attributeCliparts[tabAttributeId] = {}
                    //                 }
                    //                 pzCustomizer.attributeCliparts[tabAttributeId][attribute_clipart.promize_tab_clipart_attribute_values_id] = attribute_clipart;
                    //                 pzDefaultOptions[tabAttributeId] = (attribute_clipart.is_default_option) ? attribute_clipart : '';
                    //             })
                    //             this.props.HomeComponent.setState({ pzCustomizer, pzDefaultOptions: pzDefaultOptions });
                    //         })
                    // }
                }
            });
        }, _this.pzTextDataUpdate = function (textPartData, partNames, currObjKey, property, propertyValue, pzTextDetail) {
            var _this$props2 = _this.props,
                pzCanvasObject = _this$props2.pzCanvasObject,
                promizeThreeDObj = _this$props2.promizeThreeDObj,
                pzCopyObjectsKeys = _this$props2.pzCopyObjectsKeys,
                pzCopyOuterRepeatObjects = _this$props2.pzCopyOuterRepeatObjects,
                pzCopyInnerObjKeys = _this$props2.pzCopyInnerObjKeys,
                pzCopyOuterObjKeys = _this$props2.pzCopyOuterObjKeys,
                pzIsCopyRepeatObjects = _this$props2.pzIsCopyRepeatObjects;

            var objName = currObjKey;
            var pzObject = {};var textDataFor3D = {};
            if (!(currObjKey in pzCanvasObject)) {
                var pzObjectParams = _extends({ boundary: { left: 0, top: 0, scaleX: 1, scaleY: 1, width: 100, height: 100, angle: 0 }, index: 0 }, pzTextDetail, _this.props.pzTab);
                pzObject = _this.props.HomeComponent.pzCreateCartProperties("text", pzObjectParams);
                //console.log('pzOnj', pzObject)
                //console.log("sliderHandler in")
                pzCanvasObject[currObjKey] = _extends({}, pzObject);
            } else {
                pzObject = _extends({}, pzCanvasObject[currObjKey]);
            }
            pzCanvasObject[currObjKey]['partNames'] = [partNames[0]];
            pzCanvasObject[currObjKey][property] = parseInt(propertyValue);

            if (!pzCopyOuterRepeatObjects.includes(currObjKey) && (currObjKey.includes(pzCopyOuterObjKeys[0]) || currObjKey.includes(pzCopyOuterObjKeys[1]))) {
                pzCopyOuterRepeatObjects.push(currObjKey);
            }
            if (!pzCopyObjectsKeys.includes(pzObject.name)) {
                pzCopyObjectsKeys.push(pzObject.name);
            }

            // for both sides 

            if (pzIsCopyRepeatObjects) {

                //const objName = currObjKey;

                var name = '';
                var isSameObject = 0,
                    tabAttributeId = 0;

                if (objName.includes(pzCopyOuterObjKeys[0]) || objName.includes(pzCopyOuterObjKeys[1])) {
                    isSameObject = 1;
                } else if (objName.includes(pzCopyInnerObjKeys[0]) || objName.includes(pzCopyInnerObjKeys[1])) {
                    isSameObject = 2;
                }

                if (isSameObject == 1) {
                    if (pzCopyOuterObjKeys[0].includes('text')) {
                        //console.log(pzCopyOuterObjKeys, "pzCopyOuterObjKeys")
                        if (pzCopyInnerObjKeys[0].includes('text')) {
                            name = objName.replace(pzCopyOuterObjKeys[0], pzCopyInnerObjKeys[0]);
                            tabAttributeId = pzCopyInnerObjKeys[0].split('_')[1];
                        } else if (pzCopyInnerObjKeys[1].includes('text')) {
                            name = objName.replace(pzCopyOuterObjKeys[0], pzCopyInnerObjKeys[1]);
                            tabAttributeId = pzCopyInnerObjKeys[1].split('_')[1];
                        }
                    } else if (pzCopyOuterObjKeys[1].includes('text')) {
                        //name = objName.replace(pzCopyOuterObjKeys[0], pzCopyInnerObjKeys[0])
                        //console.log(pzCopyOuterObjKeys, "pzCopyOuterObjKeys one")

                        if (pzCopyInnerObjKeys[0].includes('text')) {
                            name = objName.replace(pzCopyOuterObjKeys[1], pzCopyInnerObjKeys[0]);
                            tabAttributeId = pzCopyInnerObjKeys[0].split('_')[1];
                        } else if (pzCopyInnerObjKeys[1].includes('text')) {
                            name = objName.replace(pzCopyOuterObjKeys[1], pzCopyInnerObjKeys[1]);
                            tabAttributeId = pzCopyInnerObjKeys[1].split('_')[1];
                        }
                    }
                } else if (isSameObject == 2) {
                    if (pzCopyInnerObjKeys[0].includes('text')) {
                        //console.log(pzCopyOuterObjKeys, "pzCopyOuterObjKeys 2")
                        //name = objName.replace(pzCopyInnerObjKeys[0], pzCopyOuterObjKeys[0])
                        if (pzCopyOuterObjKeys[0].includes('text')) {
                            name = objName.replace(pzCopyInnerObjKeys[0], pzCopyOuterObjKeys[0]);
                            tabAttributeId = pzCopyOuterObjKeys[0].split('_')[1];
                        } else if (pzCopyOuterObjKeys[1].includes('text')) {
                            name = objName.replace(pzCopyInnerObjKeys[0], pzCopyOuterObjKeys[1]);
                            tabAttributeId = pzCopyOuterObjKeys[1].split('_')[1];
                        }
                    } else if (pzCopyInnerObjKeys[1].includes('text')) {

                        //console.log(pzCopyOuterObjKeys, "pzCopyOuterObjKeys  2one")
                        //name = objName.replace(pzCopyInnerObjKeys[0], pzCopyOuterObjKeys[0])
                        if (pzCopyOuterObjKeys[0].includes('text')) {
                            name = objName.replace(pzCopyInnerObjKeys[1], pzCopyOuterObjKeys[0]);
                            tabAttributeId = pzCopyOuterObjKeys[0].split('_')[1];
                        } else if (pzCopyOuterObjKeys[1].includes('text')) {
                            name = objName.replace(pzCopyInnerObjKeys[1], pzCopyOuterObjKeys[1]);
                            tabAttributeId = pzCopyOuterObjKeys[1].split('_')[1];
                        }
                    }
                }

                var currPartNames = [partNames[0]];

                if (partNames) {
                    //partNames = linkModelAttr[0].part_names;
                    if (partNames[0] == "outside") {
                        currPartNames[0] = "inside";
                    } else {
                        currPartNames[0] = "outside";
                    }
                }
                pzCanvasObject[name] = {};
                pzCanvasObject[name] = Object.assign({}, pzCanvasObject[currObjKey], { 'partNames': currPartNames });
                pzCanvasObject[name][property] = parseInt(propertyValue);
                pzCanvasObject[name].name = name;
                pzCanvasObject[name].tabAttrId = tabAttributeId;

                textDataFor3D[partNames[0]] = {};
                if (property == "fontSize") {
                    textDataFor3D[partNames[0]] = {
                        textData: {
                            addText: _defineProperty({}, pzTextDetail.promize_tab_attribute_id, {
                                properties: {
                                    fontSize: parseInt(propertyValue)
                                }
                            })
                        }
                    };
                    textDataFor3D[currPartNames[0]] = {
                        textData: {
                            addText: _defineProperty({}, tabAttributeId, {
                                properties: {
                                    fontSize: parseInt(propertyValue)
                                }
                            })
                        }
                    };
                } else {
                    textDataFor3D[partNames[0]] = {
                        repeatSettings: {
                            spacing: 0,
                            groupSpacing: 0,
                            objectSpacing: _defineProperty({}, pzTextDetail.promize_tab_attribute_id, parseInt(propertyValue))
                        }
                    };
                    textDataFor3D[currPartNames[0]] = {
                        repeatSettings: {
                            spacing: 0,
                            groupSpacing: 0,
                            objectSpacing: _defineProperty({}, tabAttributeId, parseInt(propertyValue))
                        }
                    };
                }

                if (!pzCopyOuterRepeatObjects.includes(name) && (name.includes(pzCopyOuterObjKeys[0]) || name.includes(pzCopyOuterObjKeys[1]))) {
                    pzCopyOuterRepeatObjects.push(name);
                }
                if (!pzCopyObjectsKeys.includes(name)) {
                    pzCopyObjectsKeys.push(name);
                }
            }
            // COPY TO BOTH
            if (pzIsCopyRepeatObjects) {
                var data3_8 = {
                    name: 'tag_component',
                    component: {
                        name: _this.props.pzBaseType ? _this.props.pzBaseType : '3/4',
                        component: {
                            name: 'tag',
                            customizationData: {
                                repeatData: {
                                    '3d-customization-normal-repeat': textDataFor3D
                                }
                            }
                        }
                    }
                    //console.log("PZATTRIBUTE BOTH ", data3_8)
                };promizeThreeDObj.updateComponent(data3_8);
            }

            _this.props.HomeComponent.setState({
                pzCanvasObject: pzCanvasObject, pzCopyObjectsKeys: pzCopyObjectsKeys, pzCopyOuterRepeatObjects: pzCopyOuterRepeatObjects
            });

            if (!pzIsCopyRepeatObjects) {
                var _data3_ = {
                    name: 'tag_component',
                    component: {
                        name: _this.props.pzBaseType ? _this.props.pzBaseType : '3/4',
                        component: {
                            name: 'tag',
                            customizationData: {
                                upload: [{}],
                                repeatData: {
                                    '3d-customization-normal-repeat': textPartData
                                }
                            }
                        }
                    }
                    //console.log("PZATTRIBUTE COMPO ", data3_8)
                };promizeThreeDObj.updateComponent(_data3_);
            }
        }, _this.pzTextSlider = function (e, pzTextDetail) {
            var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "text";
            var stateProperty = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'fontSize';

            if (type == "text" && pzTextDetail) {
                var _this$props3 = _this.props,
                    promizeThreeDObj = _this$props3.promizeThreeDObj,
                    pzCopyObjectsKeys = _this$props3.pzCopyObjectsKeys,
                    pzCopyOuterRepeatObjects = _this$props3.pzCopyOuterRepeatObjects,
                    pzCopyInnerObjKeys = _this$props3.pzCopyInnerObjKeys,
                    pzCopyOuterObjKeys = _this$props3.pzCopyOuterObjKeys,
                    pzCanvasObject = _this$props3.pzCanvasObject,
                    pzIsCopyRepeatObjects = _this$props3.pzIsCopyRepeatObjects;
                var _this$state = _this.state,
                    pzTextSpacing = _this$state.pzTextSpacing,
                    pzTextSize = _this$state.pzTextSize;

                var uploadImageCount = _this.props.HomeComponent.pzSendIncrementValueByType('image', false);
                var pzObjName = "FObject_text_" + pzTextDetail.promize_tab_attribute_id + '_0';
                var pzTargetValue = e.target.value;
                if (stateProperty == 'fontSize') {
                    pzTextSize[pzObjName] = pzTargetValue;
                    pzCanvasObject[pzObjName]['fontSize'] = parseInt(pzTargetValue);
                } else {
                    pzTextSpacing[pzObjName] = pzTargetValue;
                    pzCanvasObject[pzObjName][stateProperty] = parseInt(pzTargetValue);
                }

                _this.setState({ pzTextSpacing: pzTextSpacing, pzTextSize: pzTextSize }, function () {
                    // console.log("pzTextSize ", pzTextSize)
                    //console.log("pzTextSpacing ", pzTextSpacing)

                    var partNames = {};
                    var textPartData = {};
                    //let pzTextSpacing = this.state.pzTextSpacing[pzObjName];
                    var objectSpacing = {},
                        fontSize = 28;

                    if (pzCanvasObject[pzObjName]) {
                        //console.log("coming here")
                        if (pzCanvasObject[pzObjName].fontSize) {
                            fontSize = pzCanvasObject[pzObjName].fontSize;
                        }

                        if (pzCanvasObject[pzObjName].objectSpacing) {
                            objectSpacing = _defineProperty({}, pzTextDetail.promize_tab_attribute_id, parseInt(pzCanvasObject[pzObjName].objectSpacing));
                        }
                    } else {
                        if (pzTextSpacing && pzTextSpacing[pzObjName]) {
                            objectSpacing = _defineProperty({}, pzTextDetail.promize_tab_attribute_id, parseInt(pzTextSpacing[pzObjName]));
                        }
                        if (pzTextSize && pzTextSize[pzObjName]) {
                            fontSize = pzTextSize[pzObjName];
                        }
                    }

                    var linkModelAttr = pzTextDetail.link_model_attributes ? JSON.parse(pzTextDetail.link_model_attributes) : '';

                    if (linkModelAttr.length > 0) {
                        partNames = linkModelAttr[0].part_names;
                        partNames && Object.values(partNames).map(function (partName, idx) {

                            textPartData[partName] = {
                                textData: {
                                    addText: _defineProperty({}, pzTextDetail.promize_tab_attribute_id, {
                                        properties: {
                                            fontSize: parseInt(fontSize)
                                        }
                                    })
                                },
                                repeatSettings: {
                                    spacing: 0,
                                    groupSpacing: 0,
                                    objectSpacing: objectSpacing
                                }
                            };
                        });
                        _this.pzTextDataUpdate(textPartData, partNames, pzObjName, stateProperty, pzTargetValue, pzTextDetail);

                        /* const data3_8 = {
                            name: 'tag_component',
                            component: {
                                name: (this.props.pzBaseType) ? this.props.pzBaseType : '3/4',
                                component: {
                                    name: 'tag',
                                    customizationData: {
                                        upload: [{}],
                                        repeatData: {
                                            '3d-customization-normal-repeat': textPartData
                                        }
                                    }
                                }
                            }
                        }
                        promizeThreeDObj.updateComponent(data3_8) */
                    }
                });
            }
        }, _this.pzImageSpacingSlider = function (e, pzImgDetail) {

            e.preventDefault();
            var _this$props4 = _this.props,
                pzCanvasObject = _this$props4.pzCanvasObject,
                pzIsCopyRepeatObjects = _this$props4.pzIsCopyRepeatObjects;
            var pzImageSpacing = _this.state.pzImageSpacing;

            var objectSpacing = {};
            var textPartData = {};
            var uploadImageCount = _this.props.HomeComponent.pzSendIncrementValueByType('image', false);
            //var pzObjName = "FObject_image_" + pzImgDetail.promize_tab_attribute_id + '_' + uploadImageCount + '_' + uploadImageCount;
            //console.log("pzObjName ", pzObjName)

            Object.keys(pzCanvasObject).map(function (objKey, objIdx) {
                if (!objKey.includes('background')) {
                    var isUploadedImage = false;
                    // console.log("===> ", pzCanvasObject[objKey].tabAttrId === pzImgDetail.promize_tab_attribute_id)
                    //console.log("--> ", pzCanvasObject[objKey].tabAttrId == pzImgDetail.promize_tab_attribute_id)
                    if (pzIsCopyRepeatObjects && pzCanvasObject[objKey].customType == "uploadimage") {
                        pzImageSpacing[objKey] = parseInt(e.target.value);
                        objectSpacing[objKey] = parseInt(e.target.value);
                        pzCanvasObject[objKey].objectSpacing = parseInt(e.target.value);
                        isUploadedImage = true;
                    } else if (!pzIsCopyRepeatObjects && pzCanvasObject[objKey].tabAttrId == pzImgDetail.promize_tab_attribute_id && pzCanvasObject[objKey].customType == "uploadimage") {
                        pzImageSpacing[objKey] = parseInt(e.target.value);
                        objectSpacing[objKey] = parseInt(e.target.value);
                        pzCanvasObject[objKey].objectSpacing = parseInt(e.target.value);
                        isUploadedImage = true;
                    }

                    /* if (isUploadedImage) {
                        if (textPartData[pzCanvasObject[objKey].partNames[0]]) {
                            textPartData[pzCanvasObject[objKey].partNames[0]].repeatSettings.objectSpacing[objKey] = objectSpacing[objKey]
                        }
                        else {
                            textPartData[pzCanvasObject[objKey].partNames[0]] = {
                                repeatSettings: {
                                    objectSpacing: {
                                        [objKey]: objectSpacing[objKey]
                                    }
                                },
                            }
                         }
                    } */
                }
            });
            console.log("objectSpacing ", objectSpacing);
            console.log("pzImageSpacing ", pzImageSpacing);

            _this.props.HomeComponent.setState({ pzCanvasObject: pzCanvasObject }, function () {
                /*  if (pzIsCopyRepeatObjects) {
                     console.log("%c APPLY2dObjecs", 'background:blue; color:white')
                     this.props.HomeComponent.apply2dObjects();
                 } */

            });

            _this.setState({ pzImageSpacing: pzImageSpacing }, function () {
                //if (!pzIsCopyRepeatObjects) {
                var promizeThreeDObj = _this.props.promizeThreeDObj;


                var partNames = {};
                var textPartData = {};

                if (Object.keys(objectSpacing).length > 0) {
                    // var linkModelAttr = (pzImgDetail.link_model_attributes) ? JSON.parse(pzImgDetail.link_model_attributes) : '';

                    Object.keys(objectSpacing).map(function (objKey, objIdx) {
                        if (textPartData[pzCanvasObject[objKey].partNames[0]]) {
                            textPartData[pzCanvasObject[objKey].partNames[0]].repeatSettings.objectSpacing[objKey] = objectSpacing[objKey];
                        } else {
                            textPartData[pzCanvasObject[objKey].partNames[0]] = {
                                repeatSettings: {
                                    objectSpacing: _defineProperty({}, objKey, objectSpacing[objKey])
                                }
                            };
                        }
                    });

                    console.log("textPartData ", textPartData);

                    var data3_8 = {
                        name: 'tag_component',
                        component: {
                            name: _this.props.pzBaseType ? _this.props.pzBaseType : '3/4',
                            component: {
                                name: 'tag',
                                customizationData: {
                                    uploadData: [{}],
                                    repeatData: {
                                        '3d-customization-normal-repeat': textPartData
                                    }
                                }
                            }
                        }
                        //console.log("SPACING DATA === ", data3_8)
                    };promizeThreeDObj.updateComponent(data3_8);
                }
                //}
            });
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(PromizeAttribute, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            var tabdata = this.props.pzSubTab ? this.props.pzSubTab : this.props.pzTab;
            var tabAttributes = this.props.pzCustomizer.attributes[tabdata.promize_tab_id] ? this.props.pzCustomizer.attributes[tabdata.promize_tab_id] : {};
            if (Object.keys(tabAttributes).length == 0) {
                this.pzGetAttributeValues();
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var tabdata = this.props.pzSubTab ? this.props.pzSubTab : this.props.pzTab;
            var tabAttributes = this.props.pzCustomizer.attributes[tabdata.promize_tab_id] ? this.props.pzCustomizer.attributes[tabdata.promize_tab_id] : {};
            if (Object.keys(tabAttributes).length == 0) {
                this.pzGetAttributeValues();
            }
            return React.createElement(PZAttribute, _extends({}, this.props, { AttributeComponent: this }));
        }
    }]);

    return PromizeAttribute;
}(React.Component);